import { createContext, useContext, MutableRefObject } from 'react';

interface LayoutScrollContainerContext {
    scrollContainerRef: MutableRefObject<HTMLDivElement | null>;
    scrollContainerId: string;
}

const LayoutScrollContainerContext = createContext<LayoutScrollContainerContext | null>(null);

export const useLayoutScrollContainer = () => {
    const context = useContext(LayoutScrollContainerContext);

    return {
        scrollContainer: context?.scrollContainerRef.current || window,
        scrollContainerId: context?.scrollContainerId,
    };
};

export const LayoutScrollContainerProvider = LayoutScrollContainerContext.Provider;
